<template>
    <multiselect
        v-model="receiptIssueDate"
        :options="memberReceiptIssueDatesOptions"
        track-by="key"
        label="value"
        :multiple="false"
        :allowEmpty="allowEmptyMultiselect"
        placeholder="Seleccione"
        selectedLabel=""
        selectLabel=""
        deselectLabel=""
        @select="notifyChange">
    </multiselect>
</template>

<script>
    import Multiselect from 'vue-multiselect';
    import {memberReceiptIssueDatesOptions} from '@/constants/client-constants';

    export default {
        name: "ReceiptIssueDateSelector",
        components: {
            Multiselect
        },
        props: {
            value: Number,
            allowEmpty: Boolean
        },
        data: function () {
            return {
                receiptIssueDate: !!this.value ? this.findDateByKey(this.value) : null,
                allowEmptyMultiselect: !!this.allowEmpty,
            }
        },
        computed: {
            memberReceiptIssueDatesOptions() {
                return memberReceiptIssueDatesOptions;
            }
        },
        methods: {
            findDateByKey(key) {
                return memberReceiptIssueDatesOptions.find(option => (option.key === key));
            },
            notifyChange(receiptIssueDate) {
                this.$emit('input', receiptIssueDate.key);
            }
        },
        watch: {
            value: function () {
                if (!!this.value) {
                    this.receiptIssueDate = this.findDateByKey(this.value);
                }
            }
        }
    }
</script>

<style scoped>

</style>